import { Card, CardContent } from '@mui/material';
import React from 'react';

interface ReusableCardWithChildrenProps {
	children: React.ReactNode;
	className?: string;
	contentClassName?: string;
}

export const TaCard: React.FC<ReusableCardWithChildrenProps> = ({
	children,
	className,
	contentClassName,
}) => {
	return (
		<Card className={`${className} !rounded-[12px] !shadow-custom-button !overflow-visible `}>
			<CardContent className={contentClassName}>{children}</CardContent>
		</Card>
	);
};
